import { makeAutoObservable, runInAction, observable } from 'mobx';
import { getLocale } from '@/utils/intl';
import storage from '@/utils/storage';
import AppController from '@/api/nexus/Controller/AppController';
import UserController from '@/api/nexus/Controller/UserController';
import { getTimeZone } from '@/utils/formatTime';

type MicroConfig = {
  url: string;
  baseroute: string;
  language: string;
  apiUrl: string;
  ufileCartDom: HTMLElement;
  menuPath: string;
  publicPath: string;
  pageTabContent: HTMLElement;
} | undefined;

type AppConfig = {
  /** 多语言 */
  language?: string;
  /** 用户信息 */
  userInfo: any ;
  /** 登录信息 */
  loginInfo: any;
};

type Menu = {
  id: string;
  menu_url: string;
  menu_sort: string;
  'menu_zh-cn': string;
  'menu_zh-tw': string;
  'menu_en-us': string;
  _child?: Menu[];
};

class AppStore {
  microConfig: MicroConfig = undefined;
  hasLogin: boolean = false;
  locale: string = getLocale();
  timeZone: string = getTimeZone();
  token: string = '';
  config: AppConfig = {} as any;
  loading: boolean = false;
  menuTree: Menu[] = [];
  menuIdMap: { [key: string]: Menu } = {};
  menuList: Menu[] = [];
  pageElements: string[] = [];

  constructor() {
    makeAutoObservable(this, {
      menuTree: observable.shallow,
      menuIdMap: false,
      menuList: observable.shallow,
      pageElements: observable.shallow,
    });
  }

  setLocale(locale: string) {
    const languageMatch = locale.match(/([a-zA-Z]+)/g) ?? [];
    const localeFormat = `${(languageMatch?.[0] ?? '').toLowerCase()}-${(languageMatch?.[1] ?? '').toUpperCase()}`;
    storage.set('locale', localeFormat);
    this.locale = localeFormat;
  }

  setTimeZone(timeZone:string) {
    storage.set('timeZone', timeZone);
    this.timeZone = timeZone;
  }

  setMicroConfig(config: MicroConfig) {
    this.microConfig = config;
  }

  setToken(token: any) {
    console.log(token);
  }

  setAppConfig(config: AppConfig) {
    this.config = config;
  }
  // async refreshMenu() {
  //   const { data: menu } = await AppController.getMenu();
  //   runInAction(() => {
  //     this.menuIdMap = (function generateMenuMap(menuTree) {
  //       return menuTree.reduce((map: any, menu: any) => {
  //         map[menu.id] = menu;
  //         if (isArray(menu._child)) {
  //           Object.assign(map, generateMenuMap(menu._child));
  //         }
  //         return map;
  //       }, {});
  //     })(this.menuTree);
  //   });
  // }
  async queryAppConfig() {
    this.loading = true;
    const [
      { data: config },
    ] = await Promise.all([
      AppController.getAppConfig(),
      // this.queryPageElements(),
    ]).finally(() => runInAction(() => this.loading = false));
    runInAction(() => {
      this.setAppConfig(config);
      //菜单
      this.menuList =
        (config?.permissionInfo?.menuInfo||[]).map((item:any) => ({
          ...item,
          path: item?.url+'/*',
        })).filter((d: any) => d.url);
    });
  }
  async queryPageElements() {
    const { data } = await UserController.ajaxGetRoleElements();
    runInAction(() => {
      this.pageElements = data?.menuElementArr ?? [];
    });
    return data;
  }

  async logout() {
    await UserController.logout();
  }
}

export default new AppStore();
